// Small helpers, clearing this device, install prompt
import { useEffect, useState } from './react.js';

export function safeFileUrl(u) {
  if (/^\/api\/file\/[^/]/.test(String(u || ''))) return String(u);
  try {
    const x = new URL(String(u || ''));
    if (x.protocol === 'blob:') return x.href;
    if (x.protocol === 'https:' && ['drive.google.com', 'docs.google.com'].includes(x.hostname)) return x.href;
  } catch (_) {}
  return null;
}
// Everything Prism keeps in this browser (tender copies, offline schedule changes, preferences).
// Wiped on sign-out and when a different person signs in, so a shared computer keeps nothing behind.
export function wipeLocalData() {
  try { Object.keys(localStorage).filter(k => /^(glassbox|gbx|gbrfq|prism)/.test(k)).forEach(k => localStorage.removeItem(k)); } catch (_) {}
  try { sessionStorage.clear(); } catch (_) {}
}
export function clearDeviceData() {
  if (!window.confirm('Clear Prism\'s saved preferences on this device and sign out? Your projects stay on the server.')) return;
  window.dispatchEvent(new Event('prism-sign-out'));   // App signs out the same way as the Sign out button
}
let _installEvt = null;
window.addEventListener('beforeinstallprompt', e => {
  e.preventDefault();
  _installEvt = e;
  window.dispatchEvent(new Event('lens-installable'));
});
export function useInstallPrompt() {
  const [can, setCan] = useState(!!_installEvt);
  useEffect(() => {
    const on = () => setCan(true),
      off = () => {
        _installEvt = null;
        setCan(false);
      };
    window.addEventListener('lens-installable', on);
    window.addEventListener('appinstalled', off);
    return () => {
      window.removeEventListener('lens-installable', on);
      window.removeEventListener('appinstalled', off);
    };
  }, []);
  return can ? async () => {
    _installEvt.prompt();
    await _installEvt.userChoice;
    _installEvt = null;
    setCan(false);
  } : null;
}
